import I18n from 'I18n';
import styled from 'styled-components';
import { memo, useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProsemirrorEditor from 'hubspot-prosemirror/prosemirror/ProsemirrorEditor';
import { BOLD, ITALIC, UNDERLINE, CLEAR_FORMATTING, TEXT_ALIGN, LISTS, BLOCKQUOTE, TEXT_HIGHLIGHT, TEXT_COLOR, FONT_STYLE, FONT_SIZE, LINK } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import useHubSpotRTE from 'hubspot-prosemirror/prosemirror/useHubSpotRTE';
import { convertToHtml } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { updateCallNotes } from '../clients/updateCallNotes';
import { getPlaceholderPlugin } from 'hubspot-prosemirror/prosemirror/plugins/PlaceholderPlugin';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "CallNotesTextEditor__StyledWrapper",
  componentId: "fvlfjw-0"
})(["margin-bottom:8px;"]);
const StyledEditorWrapper = styled.div.withConfig({
  displayName: "CallNotesTextEditor__StyledEditorWrapper",
  componentId: "fvlfjw-1"
})(["border:2px solid;border-color:rgba(0,208,228,0.5);margin-bottom:8px;box-shadow:0 1px 3px rgba(0,164,189,0.3);border-radius:3px;"]);
function CallNotesTextEditor({
  engagementId,
  handleEngagementDataUpdated,
  previewTextHtmlString,
  setIsEditing
}) {
  const [editorState, setEditorState] = useHubSpotRTE(previewTextHtmlString);
  const editorConfig = useMemo(() => {
    return {
      [BOLD]: {},
      [ITALIC]: {},
      [UNDERLINE]: {},
      [CLEAR_FORMATTING]: {},
      [TEXT_ALIGN]: {},
      [LISTS]: {},
      [LINK]: {},
      [BLOCKQUOTE]: {},
      [TEXT_HIGHLIGHT]: {},
      [TEXT_COLOR]: {},
      [FONT_STYLE]: {},
      [FONT_SIZE]: {}
    };
  }, []);
  const customPlugins = useMemo(() => {
    return [getPlaceholderPlugin(I18n.text('conversations-calling-message.call-notes-editor.add-notes-placeholder'))];
  }, []);
  const handleSave = () => {
    const textEditorResults = convertToHtml(editorState);
    const payload = {
      properties: [{
        name: 'hs_call_body',
        value: textEditorResults
      }]
    };
    updateCallNotes(engagementId, payload).then(() => {
      handleEngagementDataUpdated({
        engagementId
      });
      setIsEditing(false);
    }).catch(networkError => {
      logNetworkError({
        error: new Error('Error updating call notes'),
        networkError
      });
    });
  };
  const handleCancel = () => {
    setIsEditing(false);
  };
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    "data-test-id": "call-notes-text-editor",
    children: [/*#__PURE__*/_jsx(StyledEditorWrapper, {
      children: /*#__PURE__*/_jsx(ProsemirrorEditor, {
        autoFocus: true,
        customPlugins: customPlugins,
        editorState: editorState,
        setEditorState: setEditorState,
        editorConfig: editorConfig,
        inputClassName: 'call-notes'
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: handleSave,
      use: "tertiary",
      size: "xs",
      "data-test-id": "save-call-notes-button",
      "data-selenium-test": "save-call-notes-button",
      responsive: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.call-notes-editor.save-button"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: handleCancel,
      use: "tertiary-light",
      size: "xs",
      "data-test-id": "cancel-call-notes-button",
      "data-selenium-test": "cancel-call-notes-button",
      responsive: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.call-notes-editor.cancel-button"
      })
    })]
  });
}
export default /*#__PURE__*/memo(CallNotesTextEditor);